// Define the shape of the context value
export default createContext({
  text: 'Dodo',
  setText: null,
  contextualMenu: null,
  setContextualMenu: null,
  backPath: null,
  setBackPath: null
})
